import styled from "styled-components";

import { styles } from "../Input/styles";

interface ISearchContainer {
  disabled?: boolean;
  validate?: boolean;
  error?: boolean;
  verifying?: boolean;
}

export const Container = styled.div``;

export const Input = styled.label<ISearchContainer>`
  ${styles}

  display: flex;
  align-items: center;

  &:focus-within {
    box-shadow: var(--input-focus-shadow);
  }

  input {
    border: 0;
    background: transparent;

    width: 100%;

    font-size: 1rem;
  }
`;

export const SearchIconContainer = styled.div.attrs({
  className: "search-icon",
})`
  padding-right: 16px;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TimesIconContainer = styled.button.attrs({
  className: "clear-search",
})`
  padding-left: 16px;

  display: flex;
  justify-content: center;
  align-items: center;

  border: 0;
  background: transparent;
`;
